import { InventoryProvider, MappingCollections } from '@scaleaq/sitecontrol-lib';

import { defaultChartColors } from '../chart';

const adultFemale =
  MappingCollections.inventoryProviderClassPair[InventoryProvider.LiceCountAdultFemale];
const mobile = MappingCollections.inventoryProviderClassPair[InventoryProvider.LiceCountMobile];
const caligus = MappingCollections.inventoryProviderClassPair[InventoryProvider.LiceCountCaligus];
const adultFemaleEggString =
  MappingCollections.inventoryProviderClassPair[InventoryProvider.LiceCountAdultFemaleEggString];
const adultFemaleNoEggString =
  MappingCollections.inventoryProviderClassPair[InventoryProvider.LiceCountAdultFemaleNoEggString];
export const liceColors = {
  [adultFemale]: defaultChartColors[2],
  [mobile]: defaultChartColors[0],
  [caligus]: defaultChartColors[1],
  [adultFemaleEggString]: defaultChartColors[3],
  [adultFemaleNoEggString]: defaultChartColors[4],
};
